<template>
  <div class="content">
      <van-cell-group inset>
        <ChoseGtMaterial  :gtMaterial="gtMaterial"  @changeGtMaterial="changeGtMaterial"/>
        <ChoseCargoHoldsNumbs :cargoHoldsNumbs="cargoHoldsNumbs" @oilSpillProbeChange="oilSpillProbeChange"  @changeCargoHoldsNumbs="changeCargoHoldsNumbs"/>
        <!-- 预约日期 -->
        <van-field
          readonly
          clickable
          name="calendar"
          :value="appointmentDate"
          label="预约日期"
          placeholder="点击选择日期" input-align="right"
          @click="showCalendar = true"
        />
        <van-calendar v-model="showCalendar" color="#316892" @confirm="onConfirm" :show-confirm="false" />
        <!-- 预约日期End -->
        
        <!-- 可用时间 -->
        <van-field v-show="showPdxxField"
          readonly
          clickable
          name="pdxx"
          :value="pdxx"
          label="可用时间"
          placeholder="点击选择可用时间" input-align="right"
          @click="showSteamPdxxFunc"
        />
        <van-popup v-model="showSteamPdxx" position="bottom">
          <van-picker
            title="可用时间"
            show-toolbar
            :columns="steamPdxxList"
            @confirm="onConfirmSteamPdxx"
            @cancel="onCancelSteamPdxx"
          />
        </van-popup>
        <!-- 可用时间End -->
      </van-cell-group>

      <div class="padding-box"></div>
      <van-cell-group inset>
        <van-field v-model="beizhu" autosize name="beizhu" label="备注" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhu">
          <template #label>
            <span class="input-left-label-hq">备注</span>
          </template>
        </van-field>
      </van-cell-group>


  </div>
</template>
<script>
import steamApi from "@/fetch/steamApi.js";
import { Toast } from "vant";
import ChoseGtMaterial from '@/views/Vehicle/choseGtMaterial.vue';
import ChoseCargoHoldsNumbs from '@/components/SteamComponents/choseCargoHoldsNumbs.vue'
export default{
  components: {
    ChoseGtMaterial,ChoseCargoHoldsNumbs
  },
  props: {
    gtMaterial:{
      type: String,
      default: ""
    },
  },
  data()
  {
    return {
      radio:"0",
      extendResult:[],
      appointmentDate:"",
      showCalendar:false,
      pdxx:"",
      showPdxxField:false,
      showSteamPdxx:false,
      steamPdxxList:[],
      steamPdxxListOrginal:[],
      beizhu:"",
      
      guanticaizhi:"",
      cargoHoldsNumbs:String(localStorage['cheguashu']),
    }
  },
  created()
  {
    this.$emit("update-props",false);
    this.$emit("update-info",'beizhu','');

  },

  methods:{
    //确认预约时间
    onConfirm(date) {
      this.pdxx = ''
      //this.appointmentDate = `${date.getYear() + +1900}-${date.getMonth() + 1}-${date.getDate()}`;
      this.appointmentDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      this.showCalendar = false;
      this.showPdxxField = true;
      this.querySteamPdxxList('',this.appointmentDate);
      this.$emit("update-info",'appointmentDate',this.appointmentDate);
    },
    
    
    //查询蒸洗可用时间
    querySteamPdxxList(steamPort,appointmentDate)
    {

      var that = this;
      if(appointmentDate)
      {
        var formData = new FormData();
        formData.append("workport",'');
        formData.append("appointmentTime",appointmentDate);
        steamApi.querySteamPdxxByWorkport(formData).then(function(res) {
          that.steamPdxxList = []
          var resData = JSON.parse(res);
          if (resData.respCode == "0"){
            var steamPdxxListOld = [...resData.data].sort((a,b)=>{
              const timeA = that.convertToMinutes(a.zzsj);
              const timeB = that.convertToMinutes(b.zzsj);
              return timeA - timeB;
            });
            that.steamPdxxListOrginal = steamPdxxListOld;
            var steamPdxxList = [];
            steamPdxxListOld.forEach(function(item) {
              steamPdxxList.push(item.sjd);
            });

            that.steamPdxxList = steamPdxxList
          }
          else{
            Toast.fail(resData.message);
          }
        }).catch(function(error) {
          console.log(error)
          Toast.fail(error);
        });
      }
    },
    // 辅助函数：将时间字符串转换为分钟数
    convertToMinutes(timeStr) {
    const [hours, minutes] = String(timeStr).split(':').map(Number);
    return hours * 60 + minutes;
    },
   
    //展示可用时间的项目
    showSteamPdxxFunc()
    {
      var appointmentDate = this.appointmentDate;

      if(appointmentDate == "")
      {
        Toast.fail("请选择预约时间");
        return false;
      }

      this.showSteamPdxx = true;
      this.querySteamPdxxList('',appointmentDate);
    },
    //确认可用时间
    onConfirmSteamPdxx(value)
    {
      this.showSteamPdxx = false;
      if(this.steamPdxxListOrginal.length>0)
      {
        this.steamPdxxListOrginal.forEach((item) => {
          if(value == item.sjd)
          {
            this.pdxx = value;
            this.$emit("update-info",'appointmentPdxxInfo',item);
          }
        });


      }
    },
    onCancelSteamPdxx()
    {
      this.showSteamPdxx = false;
    },

    changeGtMaterial(data)
    {
      if(data)
      {

        this.guanticaizhi = data;
        this.$emit("update-info",'guanticaizhi',data);
      }
    },
    changeCargoHoldsNumbs(data) {
      if(data){
        this.cargoHoldsNumbs = data;
        this.$emit("update-info",'cargoHoldsNumbs',data);
      }
    },
    //是否有溢油探头子组件传过来的值
    oilSpillProbeChange(data) {
      if (data) {
        this.$emit("update-info", 'isOilSpillProbe', data);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.content {
    margin: 1rem 0 6.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    .padding-box{
      height: 1rem;
    }
    .check-tool-title{
      margin-left: 1rem;
      margin-bottom: .5rem;
      color: #cccccc;
    }
}
</style>
